import styled, { css } from 'styled-components';
import * as mixins from 'view/styles/mixins';
import * as bp from 'view/styles/breakpoints';
import * as transitions from 'view/styles/transitions';
import { SIDEBAR_WIDTH_LARGE_VIEWPORT, SIDEBAR_HEIGHT_SMALL_VIEWPORT, EXPAND_TIME_MS } from '../styled';

interface ContainerPusherProps {
    isOpen: boolean;
}

export const ContainerPusher = styled.div<ContainerPusherProps>`
    will-change: padding-right;
    transition: padding-right
        ${(props) => (props.isOpen ? transitions.timingFunctions.easeOut : transitions.timingFunctions.easeIn)}
        ${EXPAND_TIME_MS}ms;

    ${(props) =>
        mixins.applyIf(
            props.isOpen,
            css`
                padding: ${SIDEBAR_HEIGHT_SMALL_VIEWPORT} 0 0 0;
            `
        )};

    ${bp.fromMedium.css<ContainerPusherProps>`
        ${(props) =>
            mixins.applyIf(
                props.isOpen,
                css`
                    padding: 0 ${SIDEBAR_WIDTH_LARGE_VIEWPORT} 0 0;
                `
            )};
    `};
`;
